import { GOAL_ROUTE_ID } from './common';
import GoalManagement from './components/GoalManagement';

export default {
    [GOAL_ROUTE_ID]: () => <GoalManagement />
};
